export default function ResidentialRemodelingHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/623866d6eb0f901ba3d6d7b58605856b.jpg"
          alt="Residential Remodeling Contractors in El Paso"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Residential Remodeling Contractors in El Paso
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-white/95">
          Transform your home with expert remodeling services. Find licensed, insured contractors specializing in kitchen, bathroom, and whole-home renovations throughout El Paso.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#directory" className="px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Find Contractors
          </a>
          <a href="#checklist" className="px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap">
            Contractor Checklist
          </a>
        </div>
      </div>
    </section>
  );
}
